// extracted by mini-css-extract-plugin
export default {"row":"Timeline_row__YQDXY","parent-task-color":"Timeline_parent-task-color__Xkm2Q","border-subcontract":"Timeline_border-subcontract__3r+Nc"};